// 主登录页面翻译
import registerModule from "./register.js";
import forgotModule from "./forgot.js";
import verifyModule from "./verify.js";
import bindingModule from "./binding.js";
import codegoogleModule from "./codegoogle.js";

// 主登录页面内容
const main = {
  // 页面标题和欢迎信息
  title: "用户登录",
  welcome: "欢迎使用图链系统",
  subtitle: "请输入您的账号信息",

  // 表单字段
  username: "用户名",
  password: "密码",
  usernamePlaceholder: "请输入账号",
  passwordPlaceholder: "请输入密码",

  // 按钮和链接
  login: "登 录",
  loginButton: "立即登录",
  forgotPassword: "忘记密码？",
  noAccount: "还没有账户？",
  register: "注册",
  accountLoginTab: "账号登录",
  phoneLoginTab: "手机登录",
  confirm: "确认",
  returnToLogin: "返回登录",

  // 验证码相关
  verificationCode: "验证码",
  verificationCodePlaceholder: "请输入验证码",
  identityVerificationTitle: "身份验证码",
  howToUseAuthenticator: "如何使用身份验证器？",
  howToViewGoogleAuth: "如何查看谷歌验证码？",
  howToUseGoogleCode: "如何使用谷歌验证码",
  googleAuthBinding: "谷歌验证器绑定",

  // 消息提示
  loginSuccess: "登录成功",
  loginFailed: "登录失败",
  verificationTimeExpired: "验证时间已过期，请重新登录",
  loading: "加载中",

  // 表单验证
  usernameRequired: "请输入账号",
  passwordRequired: "请输入密码",
  usernameLength: "用户名长度应在2-20个字符之间",
  passwordLength: "密码长度应在2-16个字符之间",
  verificationCodeRequired: "请输入验证码",
  verificationCodeLength: "验证码长度应在2-5个字符之间",
  phoneRequired: "请输入手机号",
  phoneFormatError: "请输入正确的手机号格式",
  smsCodeRequired: "请输入验证码",
  smsCodeLength: "验证码长度为4-6位",

  // 其他
  rememberMe: "记住我",
  switchToRegister: "还没有账号？立即注册",
  welcomeBack: "欢迎回来",
  resendCaptcha: "重新发送({time})",
  captchaSentSuccess: "验证码已发送，请注意查收",
  successDialog: {
    defaultTitle: "操作成功",
    defaultSubtitle: "添加企业微信申请更多服务",
    defaultConfirm: "确定",
  },
};

export default {
  ...main,
  // 子模块
  registerModule,
  forgotModule,
  verifyModule,
  bindingModule,
  codegoogleModule,
};
